import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';
import { Link } from '@lyse-as/formds-react';

import { SmallContainer } from 'src/components/container';
import { ImagesSlider } from 'src/components/images-slider';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3, spacing4, spacing5, spacing6, spacing7, spacing9 } from 'src/styles/spacing';

export const StyledImagesSlider = styled(ImagesSlider)`
  margin: 0 auto ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    padding-top: ${spacing7};
    margin: 0 auto ${spacing6};
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing3};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing5};
  }
`;

export const StyledAlertContainer = styled.div`
  margin-top: ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-top: ${spacing5};
  }
`;

export const StyledContainer = styled(SmallContainer)`
  margin-bottom: ${spacing9};
`;

export const StyledPriceContainer = styled.div`
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: ${spacing1};
  }
`;

export const StyledPrice = styled(Typography)`
  text-align: right;
  margin-left: ${spacing1};
  white-space: nowrap;
`;

export const StyledPrices = styled.div`
  margin-bottom: ${spacing3};
  padding-top: ${spacing4};
  border-top: solid 1px ${colorSecondary200};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing4};
    padding-top: ${spacing5};
  }
`;

export const StyledReturnNote = styled(Typography)`
  margin-top: ${spacing2};
`;

export const StyledLink = styled(Link)`
  cursor: pointer;
  margin: ${spacing3} 0 0;
`;
